import React from 'react';
import { cn } from '../lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[88px] w-full border border-slate-300 bg-white font-body text-text-heading transition-interactive placeholder:text-text-muted',
          'rounded-xl px-4 py-3 text-sm leading-relaxed',
          'focus:border-statura-green focus:outline-none focus:ring-[3px] focus:ring-statura-green/20',
          'resize-y',
          error && 'border-red-300 focus:border-red-300 focus:ring-red-100',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
